var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"accrual-status",class:[_vm.statusColorClass]},[_c('div',{staticClass:"accrual-status__marker"}),_c('p',{staticClass:"accrual-status__text"},[_vm._v(" "+_vm._s(_vm.statusName)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }